(function ($) {
    'use strict';

    var SELECTOR = '[data-member-approve-policy]';
    var MEMBER_APPROVE_POLICY_API_URL = '/:lang/api/members/:id/approve-policy';

    var $html = $('html');
    var $body = $('body');

    var MemberApprovePolicy = {};

    MemberApprovePolicy.getMemberApprovePolicyUrl = function (id) {
        return MEMBER_APPROVE_POLICY_API_URL
            .replace(':lang', $html.attr('lang'))
            .replace(':id', id)
        ;
    };

    MemberApprovePolicy.onClick = function (event) {
        event.preventDefault();

        var $element = $(this),
            id = $element.data('member-approve-policy'),
            apiUrl = MemberApprovePolicy.getMemberApprovePolicyUrl(id)
        ;

        $element.data('member-approve-policy.state', 'loading');
        $element.addClass('is-loading');

        $.ajax(apiUrl, {method: 'POST'})
            .done(function(data) {
                if (! data.ok) {
                    console.error('unknow error');
                    return;
                }

                window.location.reload()
            })
            .always(function () {
                $element.data('member-approve-policy.state', null);
                $element.removeClass('is-loading');
            })
        ;
    };

    $(document).ready(function () {
        $body.on('click.member-approve-policy', SELECTOR, MemberApprovePolicy.onClick);
    });

})(require('jquery'));
